<template>
    <nav class="menu-container">
     <h3> <!-- <font color="#00AB39">E3路</font>-->4路<br>深圳4路公交车路线[常规线路]</h3> 
运行时间：<br>
银湖总站-银湖总站 06:30-21:00<br>
参考票价：一票制2元<br>
公交公司：深圳巴士集团股份有限公司<br>
<br><br>

三祝里—科学馆地铁接驳站<br>

<ol>
<li>银湖总站</li>
<li>金湖山庄</li>
<li>银湖蓝山</li>
<li>银湖山庄</li>
<li>银湖汽车站(2)</li>
<li>体育馆东</li>
<li>市健研中心</li>
<li>通新岭地铁站</li>
<li>市总工会</li>
<li>科学馆地铁公交接驳站</li>  
</ol>

<br><br>

科学馆地铁接驳站—三祝里<br>

<ol>
<li>科学馆地铁公交接驳站</li>
<li>科学馆地铁站</li>
<li>市总工会</li>
<li>通新岭地铁站</li>
<li>市健研中心</li>
<li>体育馆东</li>
<li>银湖汽车站(1)</li>
<li>金湖山庄</li>
<li>银湖总站</li>
</ol>

     <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
    </nav>
  </template>
  
  <script>
  import Icon from "@/components/Icon";
  export default {
    components: {
      Icon,
    },
    data() {
      return {
        items: [
          // 模板         {
          //  name: "azhan",
          //  title: "A站",
          //  icon: "chat",
          //  exact: true,
          //  },
  
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
        ],
      };
    },
  };
  </script>
  
  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(67, 47, 221);
      }
    }
  }
//ol 列表数字改为圆圈  
  ol {
  counter-reset: section;
  list-style: none;
}

li {
  margin: 0 0 10px 0;
  line-height: 25px;
}

li:before {
  content: counter(section);
  counter-increment: section;
  display: inline-block;
  width: 25px;
  height: 25px;
  margin: 0 10px 0 0;
  border: 1px solid #228B22;  //绿色，同左边主导航一样颜色 #228B22
  border-radius: 100%;
  text-align: center;
}
  </style>
  
  
  
  
  
  